<template>
 <v-app class="app">
    <AppBar />
    <v-main>
    <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>

    <div v-show="!showSkeleton">
      <div id="container" class="pt-8 px-3 mb-10">

        <!-- Título -->
        <div class="display-1">Monitor de Operadores</div>

        <!-- Opções -->
        <div class="my-4">
          <v-row align="baseline">

            <!-- Seletor de Tempo -->
            <v-col
              class="dense"
              cols="12"
              sm="4"
            >
              <v-select
                v-model="temposSelecionados"
                :items="tempos"
                small-chips
                label="Tempo"
                multiple
                outlined
                dense
                v-on:input="limitaSelecaoDeTempos"
              >
              <template>
                <v-chip>
                  <span class="pt-n2">{{ temposSelecionados }}</span>
                </v-chip>
              </template>
              </v-select>
            </v-col>

            <!-- Seletor de Departamentos ou Operadores  -->
            <v-col
              class="dense"
              cols="12"
              sm="4"
            >
              <v-col v-if="grupo == 'departamento'">               
                <v-autocomplete
                  dense
                  outlined
                  multiple
                  v-model="departamentosSelecionados"
                  :items="departamentos"
                  label="Departamento"
                  :error-messages= "departamentoErrors"
                  @input="$v.departamentosSelecionados.$touch()"
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0">{{ item.text }}</span>
                    <v-chip v-if="index === 1" small>
                      <span class="caption"> (+{{ departamentosSelecionados.length - 1 }}) </span>
                    </v-chip>
                  </template>
                  <template v-slot:prepend-item >
                    <v-list-item ripple @click="toggleDepartamento">
                      <v-list-item-action>
                        <v-icon :color="departamentosSelecionados.length > 0 ? 'indigo darken-4' : ''">
                          {{ iconDepartamento }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Selecionar Todos
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2" />
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col v-if="grupo == 'operador'">
                <v-autocomplete
                  v-model="form.operadores"
                  :items="operadores"
                  outlined
                  multiple
                  dense
                  :label="'Operadores'"
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0">{{ item.text }}</span>
                    <v-chip v-if="index === 1" small>
                      <span class="caption">
                        (+{{ form.operadores.length - 1 }})
                      </span>
                    </v-chip>
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggle">
                      <v-list-item-action>
                        <v-icon
                          :color="form.operadores.length > 0 ? 'indigo darken-4' : ''"
                        >
                          {{ icon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Selecionar Todos
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2" />
                  </template>
                </v-autocomplete>
              </v-col>

              <v-radio-group v-model="grupo" row dense class="mt-n3 pl-2">
                  <v-radio
                    label="Departamentos"
                    value="departamento"
                    @change="radioDepartamentoSelecionado"
                  ></v-radio>
                  <v-radio
                    label="Operador"
                    value="operador"
                    @change="radioOperadorSelecionado"
                  ></v-radio>
                </v-radio-group>
            </v-col>

            <!-- Checkboxes -->
            <v-col
            class="dense"
            cols="12"
            sm="4"
            >
              <v-row>
                <v-checkbox
                  class="pl-2 pr-8"
                  v-model="incluiEntrada"
                  label="Entrada"
                  :disabled="incluiEntrada == true && incluiSaida == false "
                ></v-checkbox>
                <v-checkbox
                  class="pr-8"
                  v-model="incluiSaida"
                  label="Saída"
                  :disabled="incluiEntrada == false && incluiSaida == true "
                ></v-checkbox>
                <v-checkbox
                  class="pr-8"
                  v-model="incluiIndisponiveis"
                  label="Indisponíveis"
                ></v-checkbox>
            <!-- Legenda -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="#283593" fab>mdi-information-outline</v-icon>
                  </template>
                  <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #037CD6;">&#9632;</span>Online</span></div>
                  <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #2C9437;">&#9632;</span>Disponível</span></div>
                  <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #D3201F;">&#9632;</span>Ocupado</span></div>
                  <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #FFB301;">&#9632;</span>Pausado</span></div>
                  <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #FB8C00;">&#9632;</span>Lig. em Espera</span></div>
                  <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #C2C2C2;">&#9632; </span>Indisponível</span></div>
                </v-tooltip>
              </v-row>
            </v-col>
          </v-row>
        </div>
      <!-- /Fim das opções -->
      
      <!-- Tabela -->
      <div class="containerTabela">
        <TabelaMonitorOperador :temposSelecionados=temposSelecionados :incluiEntrada="incluiEntrada" :incluiSaida="incluiSaida" :incluiIndisponiveis="incluiIndisponiveis" :operadoresOuDepartamentosSelecionados="form.operadores" />
      </div>
      <!-- Fim da Tabela -->

      <!-- /Fim do container -->
      </div>
    </div>
    </div>
    </v-main>
    <Footer/>
     </v-app>
</template>

<script>
import AppBar from '../_components/AppBar'
import Footer from '@/componentes/Footer'
import TabelaMonitorOperador from '../_components/TabelaMonitorOperador'
import { registerVuexModule } from '@/utils/vuexUtils'
import monitorOperadorStore from '../_store'
import { mapActions, mapGetters } from 'vuex'
import { validateComputed, validateData } from '../_validates'

export default {
  name: 'MonitorOperadorCallCenterHome',
  components: { AppBar, Footer, TabelaMonitorOperador },

  async created () {
    registerVuexModule (this.$store, "monitorOperadorStoreDados", monitorOperadorStore)
    await this.listarDepartamentos()
    await this.listarOperadores()

    this.departamentos = this.getDepartamentos.map(departament =>({
      text: `${departament.codigo} - ${departament.description}`,
      value: departament._id,
    }))
    this.operadores = this.getOperadores.map(operador => ({
      value: `${operador.usuario}-${operador.numero}`,
      text: `${ (!operador.active) ? 
        `${operador.numero} - ${operador.usuario} - Desativado `: 
        `${operador.numero} - ${operador.usuario}`}`,
      // disabled: !operador.active,

    }))

    this.showSkeleton = false

  },
  
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    showSkeleton:true,
    //select tempos
    tempos: [
      {
        text: 'Diário',
        value: "diario",
        disabled: false,
      },
      {
        text: 'Semanal',
        value: "semanal",
        disabled: false,
      },
      {
        text: 'Mensal',
        value: "mensal",
        disabled: false,
      }
    ],
    temposSelecionados: ["diario", "semanal"],
    //select de operadores e departamentos
    grupo:"departamento",
    departamentos: [],
    departamentosSelecionados: [],
    operadores: [],
    operadoresSelecionados: [],
    form:{
      operadores: [],
    },
    //checkboxes
    incluiEntrada: true,
    incluiSaida: true,
    incluiIndisponiveis: false,
  }),


  computed: {
    ...validateComputed,
    ...mapGetters('monitorOperadorStoreDados', ['getDepartamentos', 'getOperadores']),

    todosOperadoresSelecionados() {
      return this.form.operadores.length === this.operadores.length
    },
    algunsOperadoresSelecionados() {
      return this.form.operadores.length > 0 && !this.todosOperadoresSelecionados
    },
    icon() {
      if (this.todosOperadoresSelecionados) return 'mdi-close-box'
      if (this.algunsOperadoresSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    todosDepartamentosSelecionados() {
      return this.departamentosSelecionados.length === this.departamentos.length
    },
    algunsDepartamentosSelecionados() {
      return this.departamentosSelecionados.length > 0 && !this.todosDepartamentosSelecionados
    },
    iconDepartamento() {
      if (this.todosDepartamentosSelecionados) return 'mdi-close-box'
      if (this.algunsDepartamentosSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    departamentoEhVazio(){
      if(this.operadoresDoDepartamento.length == 0){
        return true
      }else{
        return this.operadoresDoDepartamento.filter(value => value.length !== 0)
      }
    },

    operadoresDoDepartamento(){
      var agents = []
      if(this.departamentosSelecionados !== undefined){
        this.departamentosSelecionados.forEach(id =>{
          this.getDepartamentos.forEach(departamentos =>{
            if(id == departamentos._id){
              agents.push(departamentos.agentsDepartamento)
            }
          })
        })
      }
      return agents
    },


    departamentosParaAgents(){
      var agents = []
      this.getDepartamentos.forEach(departament =>{
        departament.agentsDepartamento.forEach(agent =>{
          let teste = {
            text: `${agent.numero} - ${agent.usuario}` ,
            value: agent._id,
          }
          if(!agents.some(e => e.value == agent._id)){
            agents.push(teste)
          }
        })
      })
      return agents
    },

  },


  methods: {
      ...mapActions('monitorOperadorStoreDados', ['listarDepartamentos', 'listarOperadores']),

      radioDepartamentoSelecionado() {
        this.departamentosSelecionados = [];
      },
      radioOperadorSelecionado() {
        this.form.operadores = [];
      },

      limitaSelecaoDeTempos(e) {
        if(window.innerWidth < 1500 && e.length > 2) {
          e.pop()
          // console.log(e)
          // this.tempos.forEach(tempo => {
            // console.log(tempo.value, "tempo.value")
            // console.log(e[2])
              // if(tempo.value == e[2]) {
                // tempo.disabled = true
              // }
          // })
        // }
        // if(e.length == 1){
        //   this.tempos.forEach(tempo => {
        //     if(tempo.value == e[0]){
        //       tempo.disabled = true
        //     }
        //   })
        // } else {
        //   this.tempos.forEach(tempo => {
        //     tempo.disabled = false
        //   })
        }
      },

      toggle() {
      this.$nextTick(() => {
        if (this.todosOperadoresSelecionados) {
          this.form.operadores.splice(0)
        } else {
          this.form.operadores.splice(0)
          this.form.operadores = this.operadores.map(operador => operador.value)
        }
      })
    },

    toggleDepartamento(){
      this.$nextTick(() => {
        if (this.todosDepartamentosSelecionados) {
          this.departamentosSelecionados.splice(0)
        } else {
          this.departamentosSelecionados.splice(0)
          this.departamentosSelecionados = this.departamentos.map(departament => departament.value)
        }
      })
    },

    filtraAgentPorDepartamento(departamentoSelected){
      this.form.operadores.splice(0)
      departamentoSelected.forEach(departamento =>{
        departamento.forEach(operadores =>{
          if(!(this.form.operadores == undefined))
          {
            if((this.form.operadores.findIndex(operadorForm => operadorForm === operadores._id)) === -1){
              this.form.operadores.push(`${operadores.usuario}-${operadores.numero}`)
            }
          }
        })   
      })
    },
  },

  validations: {
    ...validateData,
  },

  watch:{
    departamentosSelecionados: function() {
      this.filtraAgentPorDepartamento(this.operadoresDoDepartamento)
    },
  },

}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
.centralizaLegenda {
  display: flex; align-items: center; justify-items: center;
}
.quadradoLegenda {
  font-size: 35px; text-shadow: 1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff; margin-right: 4px;
}
</style>
